export default "__VITE_ASSET__DbITVmP3__"